import { Component, Inject, Injector, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UserProfileModel } from "src/app/core/models/user-profile";
import { ApiService } from "src/app/core/services/shared/api.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { NotificationService } from "src/app/core/services/shared/notification.service";
import { HttpService, CodehelpService } from "virtue-form";
import { Location } from "@angular/common";
import { CancelInfoComponent } from "../shared/dialog/cancel-info/cancel-info.component";
import { TuiDialogService } from "@taiga-ui/core";
import { PolymorpheusComponent } from "@tinkoff/ng-polymorpheus";
@Component({
  selector: "app-my-accounts",
  templateUrl: "./my-accounts.component.html",
  styleUrls: ["./my-accounts.component.scss"],
})
export class MyAccountsComponent implements OnInit {
  hide = true;
  newhide = true;
  confirmhide = true;
  oldPassword: string = "";
  newPassword: string = "";
  confirmPassword: string = "";
  username: string = "";
  previousPageUrl: number;
  userProfile: UserProfileModel;
  pricingPlan: boolean = false;
  planAndSubscriptions: boolean = false;
  priceList: any[] = [];
  showLoader: boolean = false;

  priceId: string = "";
  selectedPrice: string = "";
  organizationname: any;
  userprofile: any;
  subscriptionData: any;
  constructor(
    private router: Router,
    public apiService: ApiService,
    private notificatioService: NotificationService,

    public globalVariable: GlobalVarService,
    private location: Location,
    private httpService: HttpService,
    private codeHelp: CodehelpService,
    private notificationService: NotificationService,

    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {}

  ngOnInit(): void {
    this.pricingPlan = true;
    this.organizationname = JSON.parse(this.codeHelp.getLoggedUserDetail());
    this.userprofile = JSON.parse(this.codeHelp.getUserProfile());
    this.username = this.userprofile?.username;

    this.previousPageUrl = this.globalVariable.previousPageUrl;
    this.getUserProfile();
    this.currentPlan();
    console.log(typeof this.codeHelp.getUserProfile());
    console.log(this.codeHelp.getUserProfile());
    if (this.globalVariable.PriceList.length > 0) {
      this.priceList = this.globalVariable.PriceList;
      this.priceId = this.priceList[0].priceStripeId;
      this.selectedPrice = this.priceList[0].priceStripeId;
      console.log(this.priceList, "priceList");
    } else {
      this.apiService.getProductKeyontool((res: any) => {
        if (res) {
          this.apiService.getpriceList(res.productId).then((resp: any) => {
            this.priceList = resp;
          });
        }
      });
    }
  }

  getPriceTitle(interval: string): string {
    // Add logic to determine the label based on the interval
    // For example, return "Month" if the interval is "month"
    return interval === "month"
      ? "Monthly"
      : "Your Custom Label" || interval === "year"
      ? "Annual"
      : "Your Custom Label";
  }

  getPriceAmount(priceItem: any) {
    // Add logic to format the price amount based on the priceItem
    // For example, format as "$" + priceItem.unit_amount
    return "$" + priceItem?.unit_amount;
  }

  getPriceLabel(interval: string): string {
    // Add logic to determine the label based on the interval
    // For example, return "Month" if the interval is "month"
    return interval === "month"
      ? "Month"
      : "Your Custom Label" || interval === "year"
      ? "Year"
      : "Your Custom Label";
  }

  submit(priceId: string) {
    this.showLoader = true;
    this.apiService
      .PaymentFromTool(this.globalVariable.ProductKey, priceId)
      .then(
        (resp: any) => {
          if (resp) {
            this.showLoader = false;
            if (resp.created == true) {
              if (resp?.linkUrl && resp?.errorMsg == null) {
                this.showLoader = false;
                window.open(resp?.linkUrl, "_blank");
              }
            }
          }
        },
        (error) => {
          if (error.status == "500" || error.status) {
            this.notificatioService.showNotification(
              "Please enter valid coupon code.",
              "Invalid coupon code",
              true,
              "warning"
            );
          }
        }
      );

    // this.otp = true;
    // if (this.isDisabledCouponCode == true) {
    //   data.value.coupon = this.model.coupon;
    // }
  }
  goBack() {
    const currentUrl = this.location.path();

    // if (this.previousPageUrl != null && this.previousPageUrl != undefined) {
    this.globalVariable.myAccountPageUrl = currentUrl;

    // console.log(this.globalVariable.myAccountPageUrl);
    // this.globalVariable.redirectPage(
    //   this.previousPageUrl,
    //   true,
    //   true,
    //   false
    // );

    this.globalVariable.redirectPage(this.previousPageUrl, true, true, true);

    //  location.reload();
    // }
  }

  getUserProfile() {
    const user = JSON.parse(this.codeHelp.getUserProfile());

    this.httpService
      .get("userProfile", user.id, this.globalVariable.isTokenLogin)
      .then((response: UserProfileModel) => {
        this.userProfile = response;
        console.log(this.userProfile);

        this.codeHelp.setUserProfile(JSON.stringify(response));
      });
  }
  private dialogCancelInfo = this.dialogService.open<any>(
    new PolymorpheusComponent(CancelInfoComponent, this.injector),
    {
      data: {},
      dismissible: true,
      closeable: false,
      label: "",
      size: "s",
    }
  );
  onCancelSubscription() {
    this.dialogCancelInfo = this.dialogService.open<any>(
      new PolymorpheusComponent(CancelInfoComponent, this.injector),
      {
        data: this.subscriptionData,
        dismissible: false,
        size: "s",
      }
    );
    this.dialogCancelInfo.subscribe({
      next: (data) => {
        if (data == true || data == "true") {
          this.httpService
            .post(
              "payment/cancelSubscription",
              this.userProfile,
              this.globalVariable.isTokenLogin
            )
            .then((resp: any) => {
              console.log(resp);

              if (resp.success == false) {
                this.notificationService.showNotification(
                  resp.errorMessage,
                  "Subscription not found",
                  true,
                  "warning"
                );
              } else {
                this.notificationService.showNotification(
                  resp.errorMessage,
                  "Successfully cancelled",
                  true,
                  "success"
                );
              }
            });
        }
      },
      complete: () => {
        {
        }
        console.info("Dialog closed");
      },
    });
  }
  currentPlan() {
    this.apiService.currentPlan(this.userprofile?.id).then(
      (resp: any) => {
        if (resp) {
          console.log(resp, "Response");
          this.subscriptionData = resp;
        }
      },
      (error) => {
        if (error.status == "500" || error.status) {
          ("An error occurred while fetching data. Please try again later.");
        }
      }
    );
  }
  pricingPlanClickEvent() {
    this.pricingPlan = true;
    this.chngePasswodformshow = false;
    this.planAndSubscriptions = false;
  }
  planAndSubscriptionsClickEvent() {
    this.planAndSubscriptions = true;
    this.chngePasswodformshow = false;
    this.pricingPlan = false;
  }
  chngePasswodformshow: boolean = false;
  changepassword() {
    this.chngePasswodformshow = true;
    this.planAndSubscriptions = false;
    this.pricingPlan = false;
  }
  onSubmit() {
    // Handle form submission
  }

  changePassword() {
    if (this.newPassword === this.confirmPassword) {
      let form = {
        username: this.userprofile?.username,
        password: this.oldPassword,
      };

      this.apiService
        .checkOldPassword(form)
        .then((resp: any) => {
          if (resp.isSuccessful) {
            const body = {
              password: this.newPassword,
              code: this.userprofile.id,
            };

            this.apiService
              .resetpassword(body)
              .then((res) => {
                console.log(res, "resepass ");
                this.notificatioService.showNotification(
                  "Password has been changed successfully.",
                  "Changed Password",
                  true,
                  "success"
                );
              })
              .catch((error) => {
                console.error("Error resetting password:", error);
                this.notificatioService.showNotification(
                  "An error occurred while changing the password. Please try again later.",
                  "Password Change Failed",
                  true,
                  "error"
                );
              });
          } else {
            this.notificatioService.showNotification(
              "Please enter a valid old password.",
              "Invalid Password",
              true,
              "warning"
            );
          }
        })
        .catch((error) => {
          console.error("Error checking old password:", error);
          this.notificatioService.showNotification(
            "An error occurred while checking the old password. Please try again later.",
            "Password Verification Failed",
            true,
            "error"
          );
        });
    } else {
      // Passwords do not match, show error
      console.error("Passwords do not match.");
    }
  }
  formatDate(dateTimeString: string): string {
    if (!dateTimeString) {
      return "N/A";
    }

    const date = new Date(dateTimeString);
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const hours = date.getHours() % 12 || 12;
    const ampm = date.getHours() >= 12 ? "pm" : "am";
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${
      monthNames[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}, ${hours}:${minutes}${ampm}.`;
  }
  CurrentInfo(currentInfoSub: any) {
    if (currentInfoSub.subscriptionType && currentInfoSub.couponUsed != null) {
      return "Trail Subscription";
    } else {
      if (currentInfoSub.subscriptionType && currentInfoSub?.priceId != null) {
        const matchingSubscription = this.priceList.filter(
          (item) => item.priceStripeId === currentInfoSub.priceId
        );
        const unitAmounts = matchingSubscription.map((sub) => sub.unit_amount);
        if (unitAmounts.includes(1000) || unitAmounts.includes(60)) {
          return "Annual Subscription";
        } else {
          return "Monthly Subscription";
        }
      }
    }
  }
}
